import { Component, createRef } from 'react';
import React from 'react';
import Field from './Field';
import { ThumbSelectInputMenu } from './ThumbSelectInputMenu';

import styles from './ThumbSelectInput.module.css';

/**
 * Usage:
 *
 * <ThumbSelectInput
 *   handler=function (value, field, option) {...}
 *   label="..."
 *   options= [{ text: '...', value: ... }, ...]
 *   placeholder='...'
 *   value=... />
 */

interface Props {
  className?: string;
  handler: Function;
  label?: string;
  onFocus?: any;
  options: any;
  optionsHeader?: string;
  placeholder?: string;
  value: string;
  hiddenIds?: string[];
}

class ThumbSelectInput extends Component<Props> {

  private inputRef:any

  constructor(props){
    super(props);
    this.inputRef = createRef();
  }

  public render () {
    let className = 'select-field';
    const label = this.props.label;
    const displayValue = this.findDisplayValue();
    const option = this.findOptionByValue(this.props.value);
    const background = `url(${ displayValue })`;
    const fontName = option ? option.data.fontName : '';
    const isNumberType = option ? (option.data.type === 'Numbers') : false;
    let inputClassName = isNumberType ? styles.selectSelectedCenterThumb : styles.selectSelected;

    if (!this.props.value) {
      inputClassName += this.props.placeholder ? (' ' + styles.placeholder) : ' empty';
    }

    if (this.props.className) {
      className += ' ' + this.props.className;
    }

    return (
      <Field className={className} label={label}>
        <div
          style={{ backgroundImage: background }}
          className={inputClassName}
          onClick={() => this.showMenu()}
          ref={this.inputRef}>
          <div className={styles.thumbName}>{fontName}</div>
        </div>
        <div className={styles.trigger}></div>
      </Field>
    );
  }

  private findDisplayValue () : any {
    const value = this.props.value;
    const options = this.props.options || [];
    const len = options.length;
    let i = 0;

    for (; i < len; i++) {
      if (options[i].value === value) {
        return options[i].data.thumb;
      }
    }

    // Return the value if an option is not found
    // Replace clipart field sets the value as the clipart id
    // not to an actual option value
    return value || this.props.placeholder || ( ( options.length > 0 ) ? options[0].data.thumb : '' );
  }

  public toggle () {
    this.showMenu();
  }

  private evaluateVisible (v) {
    if ( ! this.props.hiddenIds )
      return true;
    else
      return this.props.hiddenIds.indexOf(v) === -1;
  }

  private showMenu () {
    ThumbSelectInputMenu.show({
      label: this.props.label || this.props.optionsHeader,
      options: this.props.options.filter( (o) => { return this.evaluateVisible(o.value); }),//filter out hidden ones
      selectHandler: this.select.bind(this),
      showByTarget: this.inputRef.current,
      thumbInput: true,
      value: this.props.value
    });

    if (this.props.onFocus) {
      this.props.onFocus();
    }
  }

  public select (value) {
    if(this.props.handler) {
      this.props.handler(value, this, this.findOptionByValue(value));
    }
  }

  private findOptionByValue (value) {
    const options = this.props.options || [];
    const len = options.length;
    let i = 0;

    for (; i < len; i++) {
      if (options[i].value === value) {
        return options[i];
      }
    }

    return undefined;
  }

}

export default ThumbSelectInput;